import { render, staticRenderFns } from "./DomainSearch.vue?vue&type=template&id=dbcd9ff6&scoped=true&"
import script from "./DomainSearch.vue?vue&type=script&lang=js&"
export * from "./DomainSearch.vue?vue&type=script&lang=js&"
import style0 from "./DomainSearch.vue?vue&type=style&index=0&id=dbcd9ff6&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "dbcd9ff6",
  null
  
)

export default component.exports